import { i18n } from '@international/mastodon-i18n';
import { ReportList } from './ReportList';

export default i18n.renderTranslation()(ReportList);
